<template>
  <div class="form">
    <div class="form__header">
      <h3>Авто-настройки</h3>
    </div>
    <div class="form__body">
      <h3>Качество</h3>
      <p class="form__field range">
        <span>От: ({{ formData.quality_from }})</span>
        <range-slider
          class="setup__range"
          min="0"
          max="100"
          step="5"
          v-model="formData.quality_from">
        </range-slider>
      </p>
      <p class="form__field range">
        <span>До: ({{ formData.quality_to }})</span>
        <range-slider
          class="setup__range"
          min="0"
          max="100"
          step="5"
          v-model="formData.quality_to">
        </range-slider>
      </p>

      <p class="form__field range">
        <span>Повтор(через сколько дней): ({{ formData.repeat }})</span>
        <range-slider
          class="setup__range"
          min="1"
          max="7"
          step="1"
          v-model="formData.repeat">
        </range-slider>
      </p>

      <component
        class="instructions"
        :is="trainerSettings" 
        @params_changed="changeSettings"
        :is_homework="true" 
        :homework_params="baseParams"
        :autoSettings="true"
      ></component>
    </div>

    <div class="form__footer">
      <button 
        type="button" 
        class="uk-button uk-button-primary" 
        @click="submit"
        :disabled="!isValidSettings"
      >
        Сохранить
      </button>
      <span v-show="!isValidSettings" class="warning-message">Введен уже существующий или некорректный диапазон</span>
    </div> 
  </div>
</template>

<script>
import RangeSlider from 'vue-range-slider'
export default {
  props: ['data'],
  components: { RangeSlider },
  data() {
    return {
      formData: {
        quality_from: 70,
        quality_to: 100,
        repeat: 1,
        settings: {}
      }      
    }
  },
  computed: {
    trainerSettings() {
      return require(`../../../trainer/${this.data.trainerItem.trainer.component}/components/Settings`).default;
    },
    baseParams() {
      return this.data ? _.cloneDeep(this.data.trainerItem.params) : null
    },
    isValidSettings() {
      let values = this.data.trainerItem.settings.map(item => [item.quality_from, item.quality_to])
      let isValid = true

      values.forEach(item => {
        if (this.formData.quality_from > item[0] && this.formData.quality_from < item[1]) {
          isValid = false
        }
        if (this.formData.quality_to > item[0] && this.formData.quality_to <= item[1]) {
          isValid = false
        }
        if (this.formData.quality_from >= item[0] && this.formData.quality_from < item[1] && this.formData.quality_to > item[1]) {
          isValid = false
        }
      })

      if (this.formData.quality_from >= this.formData.quality_to) {
        isValid = false
      }

      return isValid
    }
  },
  methods: {
    changeSettings(settings) {
      let obj = _.cloneDeep(settings)
      let result = {}
      let keysToRemove = ['qnt', 'steps']
      let keys = Object.keys(obj).filter(k => !keysToRemove.includes(k))

      keys.forEach(key => {
        let sum

        if (!isNaN(obj[key]) && typeof obj[key] !== 'boolean') {
          sum = obj[key] - this.data.trainerItem.params[key]

          if (!Number.isInteger(sum)) {
            sum.toFixed(1)
          }

          result[key] = sum
        }         
      })
      console.log(result)
      this.formData.settings = result
    },
    submit() {      
      let data = {
        settings: this.formData,
        index: this.data.index
      }
      this.$emit('add-auto-settings', data)
      this.$emit('close-popup')
    }
  },
  created() {
    //###### для старых тренажеров #########
    let val = {
      train: this.data.trainerItem.trainer.component + '_params',
      params: _.cloneDeep(this.data.trainerItem.params),
    }
    this.$store.commit('train/changeParams', val);
    // #################
  }
}
</script>

<style lang="scss" scoped>
.instructions {
  box-sizing: border-box;
  width: 100%;
  margin-top: 20px;
}

.setup__range {
  box-sizing: border-box;
  width: 100%;
}
</style>